import { render, staticRenderFns } from "./picture-uploader.vue?vue&type=template&id=dc4e9b46&scoped=true"
import script from "./picture-uploader.vue?vue&type=script&lang=js"
export * from "./picture-uploader.vue?vue&type=script&lang=js"
import style0 from "./picture-uploader.vue?vue&type=style&index=0&id=dc4e9b46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4e9b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc4e9b46')) {
      api.createRecord('dc4e9b46', component.options)
    } else {
      api.reload('dc4e9b46', component.options)
    }
    module.hot.accept("./picture-uploader.vue?vue&type=template&id=dc4e9b46&scoped=true", function () {
      api.rerender('dc4e9b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file-uploader/picture-uploader.vue"
export default component.exports